import type { LoginHeaderConfig } from '@wegic/login';
import { create } from 'zustand';

export interface LoginModalOpenOptions {
  onSuccess?: () => void;
  initialEmail?: string;
  header?: LoginHeaderConfig;
  dismissible?: boolean;
}

interface LoginModalState {
  visible: boolean;
  onSuccess: (() => void) | null;
  initialEmail: string | null;
  header: LoginHeaderConfig | null;
  dismissible: boolean;
  open: (options?: LoginModalOpenOptions) => void;
  close: () => void;
}

export const useLoginModalStore = create<LoginModalState>(set => ({
  visible: false,
  onSuccess: null,
  initialEmail: null,
  header: null,
  dismissible: true,
  open: options => set({
    visible: true,
    onSuccess: options?.onSuccess ?? null,
    initialEmail: options?.initialEmail ?? null,
    header: options?.header ?? null,
    dismissible: options?.dismissible ?? true,
  }),
  close: () => set({
    visible: false,
    onSuccess: null,
    initialEmail: null,
    header: null,
    dismissible: true,
  }),
}));
